import { Helmet } from "react-helmet-async";
import { Link } from "wouter";
import { QrCode, Home, ArrowRight, Search } from "lucide-react";
import { motion } from "framer-motion";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center px-4 font-sans">
      <Helmet>
        <title>Page Not Found — CommonQR</title>
        <meta name="robots" content="noindex" />
      </Helmet>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
        className="w-full max-w-md text-center"
      >
        {/* Logo */}
        <Link href="/" className="inline-flex items-center gap-2 mb-12 group">
          <QrCode className="w-7 h-7 text-indigo-600" />
          <span className="font-bold text-xl text-slate-900 group-hover:text-indigo-600 transition-colors">
            CommonQR
          </span>
        </Link>

        {/* 404 Visual */}
        <div className="relative mb-8">
          <p className="text-[120px] font-extrabold text-slate-100 leading-none select-none">
            404
          </p>
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-20 h-20 rounded-2xl bg-indigo-50 flex items-center justify-center border border-indigo-100">
              <Search className="w-9 h-9 text-indigo-400" />
            </div>
          </div>
        </div>

        {/* Message */}
        <h1 className="text-2xl font-bold text-slate-900 mb-3">
          This page doesn't exist
        </h1>
        <p className="text-slate-500 leading-relaxed mb-10">
          The link you followed may be broken, or the page may have been removed.
          If you were looking for a CommonQR profile, check the username and try again.
        </p>

        {/* Actions */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link href="/">
            <a className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-indigo-600 text-white font-semibold rounded-xl hover:bg-indigo-700 transition-colors">
              <Home className="w-4 h-4" />
              Go to homepage
            </a>
          </Link>
          <Link href="/signup">
            <a className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-slate-100 text-slate-700 font-semibold rounded-xl hover:bg-slate-200 transition-colors">
              Create your QR profile
              <ArrowRight className="w-4 h-4" />
            </a>
          </Link>
        </div>

        {/* Footer */}
        <p className="mt-16 text-xs text-slate-300">
          commonqr.com
        </p>
      </motion.div>
    </div>
  );
}
